import React, { Component } from 'react';
import config from '../Config';
import ContactAction from './ContactAction';
import logo from '../assets/images/logo.svg';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faHouzz, faInstagramSquare,  faFacebookF, faPinterestP } from '@fortawesome/free-brands-svg-icons';

class Footer extends Component {
render() {
    const location = window.location.pathname
    const icons = [
        { icon: faPhone, url: config.phone_plain, action: "tel:", title: config.phone},
        { icon: faEnvelope, url: config.email, action: "mailto:", title: config.email},
        { icon: faFacebookF, url: config.facebook_url, action: "", title: config.facebook_account_name},
        { icon: faInstagramSquare, url: config.instagram_url, action: "", title: config.instagram_account_name},
        { icon: faHouzz, url: config.houzz_url, action: "", title: config.houzz_account_name},
        { icon: faPinterestP, url: config.pinterest_url, action: "", title: config.pinterest_account_name}
    ];

    return (
        <div>
            
            {location != '/contatti' && <ContactAction></ContactAction>}

            <footer className='p-tb-2 b-primary'>
                <div className='m-c content-wrapper'>
                    <ul className='p-lr-3 m-c sm-lr-0'>
                        <li className='c-25 d-i-b v-a-m sm-c-100 sm-t-a-c'>
                            <Link className='d-i-b' to='/'>
                                <img className='v-a-m logo invert c-80' src={logo} />
                            </Link>
                        </li>

                        <li className='c-75 d-i-b v-a-m t-a-r sm-c-100 sm-t-a-c sm-p-tb-2'>
                            {icons.map((item, index) => (
                                
                                <a key={index} target="_blank" className='d-i-b' href={item.action + item.url}>
                                    <FontAwesomeIcon key={index} icon={item.icon} className='p-lr-1 icon-footer'/>
                                </a>
                            ))}
                        </li>
                    </ul>
                </div>    
            </footer>

        </div>
        );
    }
}

export default Footer;
